class BundlePage extends HTMLElement {
  connectedCallback() {
    this.urlParams = new URLSearchParams(window.location.search);
    this.isOneoff = this.urlParams.get('refill_frequency') === 'oneoff';

    this.bars = (window.bars || []).map((bar) => {
      var mode = this.isOneoff ? bar.oneoff : bar.subscription;
      return {
        id: bar.id,
        quantity: bar.quantity,
        price: mode.price,
        savingprice: mode.savingprice,
        isfreeshipping: mode.isfreeshipping,
        isdefault: mode.isdefault
      };
    });
    this.config = window.bundlePageConfig || {};

    this.cards = Array.prototype.slice.call(this.querySelectorAll('.bars-grid .bar-card'));
    this.tierBars = this.querySelectorAll('.bundle-tier-bars');
    this.priceRows = this.querySelectorAll('.bundle-price-row');
    this.quantityDisplay = this.querySelector('.bundle__default_quantity');

    this.slotsEl = this.querySelector('#slots');
    this.sizePickerDesktop = this.querySelector('#sizePickerDesktop');
    this.sizePickerMobile = this.querySelector('#sizePickerMobile');
    this.countLabel = this.querySelector('#countLabel');
    this.countLabelMobile = this.querySelector('#countLabelMobile');
    this.hintLabel = this.querySelector('#hintLabel');
    this.saveLabel = this.querySelector('#saveLabel');
    this.progressEl = this.querySelector('#progress');
    this.nowPriceEl = this.querySelector('#nowPrice');
    this.ctaButton = this.querySelector('#ctaButton');
    this.ctaButtonText = this.querySelector('#ctaButtonText');
    this.toggleBtn = this.querySelector('#footerToggle');
    this.toggleLabel = this.querySelector('#toggleLabel');
    this.selectionPanel = this.querySelector('#selectionPanel');

    if (!this.bars.length || !this.slotsEl || !this.ctaButton) return;

    this.DEFAULT_SELECTIONS = window.bundleDefaultSelections || {};

    if (this.isOneoff) {
      var renewNote = this.querySelector('.renew-note');
      if (renewNote) renewNote.classList.add('hidden');
    }

    this.state = {
      bundleId: null,
      bundleSize: 0,
      selectedUnits: [], // { index, title, image }
      panelOpen: false
    };

    this.bindEvents();
    this.setPanelOpen(false);

    var defaultBundle = null;
    this.bars.forEach((b) => {
      if (b.isdefault) defaultBundle = b;
    });
    this.setBundle(defaultBundle ? defaultBundle.id : this.bars[0].id);
  }

  bindEvents() {
    this.cards.forEach((card) => {
      var btnAdd = card.querySelector('.btn-add');
      var slotAdd = card.querySelector('.bundle-qty-add');
      var slotMinus = card.querySelector('.bundle-qty-minus');

      if (btnAdd) btnAdd.addEventListener('click', () => this.addUnit(card));
      if (slotAdd) slotAdd.addEventListener('click', () => this.addUnit(card));
      if (slotMinus) slotMinus.addEventListener('click', () => this.removeUnit(card));
    });

    this.tierBars.forEach((bar) => {
      bar.addEventListener('click', () => this.setBundle(bar.id));
    });

    if (this.toggleBtn && this.selectionPanel) {
      this.toggleBtn.addEventListener('click', () => {
        this.setPanelOpen(!this.state.panelOpen);
      });
    }

    this.ctaButton.addEventListener('click', () => {
      if (this.ctaButton.disabled) return;
      // window._uxa.push(['setCustomVariable', 1, 'xl_bars_bodywash', 'final-step', 3]);
      // window._uxa.push(['trackPageview']);
      this.addToCart();
    });
  }

  setPanelOpen(open) {
    this.state.panelOpen = open;
    if (!this.toggleBtn || !this.selectionPanel) return;
    this.selectionPanel.classList.toggle('is-collapsed', !open);
    this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.toggleLabel.textContent = open ? 'Hide selected bars' : 'View selected bars';
  }

  findBundle(id) {
    for (var i = 0; i < this.bars.length; i++) {
      if (this.bars[i].id === id) return this.bars[i];
    }
    return null;
  }

  cardByIndex(index) {
    for (var i = 0; i < this.cards.length; i++) {
      if (this.cards[i].dataset.index === index) return this.cards[i];
    }
    return null;
  }

  cardByTitle(title) {
    var needle = title.trim().toLowerCase();
    for (var i = 0; i < this.cards.length; i++) {
      var h3 = this.cards[i].querySelector('h3');
      if (h3 && h3.textContent.trim().toLowerCase() === needle) return this.cards[i];
    }
    return null;
  }

  buildDefaultSelection(quantity) {
    var defaults = this.DEFAULT_SELECTIONS[quantity];
    if (!Array.isArray(defaults)) return [];

    var units = [];
    defaults.forEach((entry) => {
      if (!entry || typeof entry.title !== 'string') return;
      var card = this.cardByTitle(entry.title);
      if (!card) return;
      var img = card.querySelector('.scent-bar__image');
      var entryQuantity = parseInt(entry.quantity, 10) || 0;
      for (var i = 0; i < entryQuantity && units.length < quantity; i++) {
        units.push({
          index: card.dataset.index,
          title: entry.title,
          image: img ? img.src : ''
        });
      }
    });

    return units;
  }

  waitForRecharge() {
    return new Promise((resolve) => {
      if (window.recharge && window.recharge.bundle) return resolve();
      var timer = setInterval(() => {
        if (window.recharge && window.recharge.bundle) {
          clearInterval(timer);
          resolve();
        }
      }, 100);
    });
  }

  updateCardUI(card, qty) {
    var btnAdd = card.querySelector('.btn-add');
    var stepper = card.querySelector('.stepper');
    var qtyDisplay = card.querySelector('.bundle-qty-value');
    var slotAdd = card.querySelector('.bundle-qty-add');

    if (qty > 0) {
      if (btnAdd) btnAdd.classList.add('hidden');
      if (stepper) stepper.classList.remove('hidden');
      if (qtyDisplay) qtyDisplay.textContent = qty;
    } else {
      if (btnAdd) btnAdd.classList.remove('hidden');
      if (stepper) stepper.classList.add('hidden');
      if (qtyDisplay) qtyDisplay.textContent = 1;
    }

    if (slotAdd) slotAdd.disabled = this.state.selectedUnits.length >= this.state.bundleSize;
  }

  syncCardQuantities() {
    var counts = {};
    this.state.selectedUnits.forEach((unit) => {
      counts[unit.index] = (counts[unit.index] || 0) + 1;
    });
    this.cards.forEach((card) => {
      this.updateCardUI(card, counts[card.dataset.index] || 0);
    });
  }

  addUnit(card) {
    if (this.state.selectedUnits.length >= this.state.bundleSize) return;
    var img = card.querySelector('.scent-bar__image');
    var title = card.querySelector('h3');
    this.state.selectedUnits.push({
      index: card.dataset.index,
      title: title ? title.textContent.trim() : '',
      image: img ? img.src : ''
    });
    this.render();
  }

  removeUnit(card) {
    var index = card.dataset.index;
    for (var i = this.state.selectedUnits.length - 1; i >= 0; i--) {
      if (this.state.selectedUnits[i].index === index) {
        this.state.selectedUnits.splice(i, 1);
        break;
      }
    }
    this.render();
  }

  removeUnitAt(slotIndex) {
    this.state.selectedUnits.splice(slotIndex, 1);
    this.render();
  }

  setBundle(id) {
    var bundle = this.findBundle(id);
    if (!bundle) return;

    var isChanging = id !== this.state.bundleId;

    this.state.bundleId = id;
    this.state.bundleSize = bundle.quantity;

    if (isChanging) {
      this.state.selectedUnits = this.buildDefaultSelection(this.state.bundleSize);
    } else if (this.state.selectedUnits.length > this.state.bundleSize) {
      this.state.selectedUnits.length = this.state.bundleSize;
    }

    this.render();
  }

  renderTierRow() {
    this.tierBars.forEach((bar) => {
      bar.classList.toggle('is-active', bar.id === this.state.bundleId);
      var bundle = this.findBundle(bar.id);
      var badge = bar.querySelector('.bundle-tier-badge');
      if (bundle && badge) badge.classList.toggle('hidden', !bundle.isfreeshipping);
    });
    if (this.quantityDisplay) this.quantityDisplay.textContent = this.state.bundleSize;
    this.priceRows.forEach((row) => {
      var rowId = row.getAttribute('data-bars');
      var rowBundle = this.findBundle(rowId);
      if (rowBundle) {
        row.innerHTML = rowBundle.price + (rowBundle.savingprice ? ' <span class="bundle-saving">(' + rowBundle.savingprice + ' saving)</span>' : '');
      }
      row.classList.toggle('hidden', rowId !== this.state.bundleId);
    });
  }

  renderSlots() {
    this.slotsEl.innerHTML = '';
    for (var i = 0; i < this.state.bundleSize; i++) {
      var unit = this.state.selectedUnits[i];
      var slot = document.createElement('div');

      if (unit) {
        slot.className = 'bundle-slot filled';
        slot.innerHTML =
          '<button type="button" class="bundle-slot-remove" aria-label="Remove ' + unit.title + '">&times;</button>' +
          '<div class="bundle-slot-visual">' + (unit.image ? '<img src="' + unit.image + '" alt="' + unit.title + '">' : '') + '</div>' +
          '<div class="bundle-slot-name">' + unit.title + '</div>';

        ((index) => {
          slot.querySelector('.bundle-slot-remove').addEventListener('click', (e) => {
            e.stopPropagation();
            this.removeUnitAt(index);
          });
        })(i);
      } else {
        slot.className = 'bundle-slot empty';
        slot.innerHTML = '<span class="bundle-slot-plus" aria-hidden="true">+</span>';
      }

      this.slotsEl.appendChild(slot);
    }
  }

  renderSizePicker(container) {
    if (!container) return;
    container.innerHTML = '';
    this.bars.forEach((bundle) => {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-size-option' + (bundle.id === this.state.bundleId ? ' active' : '');
      btn.innerHTML = bundle.quantity + ' bars' + (bundle.savingprice ? ' <span class="bundle-saving">save ' + bundle.savingprice + '</span>' : '');
      btn.addEventListener('click', () => this.setBundle(bundle.id));
      container.appendChild(btn);
    });
  }

  renderSummary() {
    var bundle = this.findBundle(this.state.bundleId);
    if (!bundle) return;

    var filled = this.state.selectedUnits.length;
    var total = this.state.bundleSize;
    var remaining = total - filled;

    this.countLabel.textContent = filled + ' of ' + total + ' selected';
    if (this.countLabelMobile) this.countLabelMobile.textContent = filled + ' of ' + total;
    if (this.hintLabel) this.hintLabel.textContent = remaining > 0 ? 'Choose ' + remaining + ' more' : '';

    this.saveLabel.classList.toggle('hidden', !bundle.savingprice);
    this.saveLabel.textContent = bundle.savingprice ? 'Save ' + bundle.savingprice : '';
    this.nowPriceEl.textContent = bundle.price;

    this.progressEl.innerHTML = '';
    for (var i = 0; i < total; i++) {
      var seg = document.createElement('div');
      seg.className = 'bundle-progress-seg' + (i < filled ? ' done' : '');
      seg.innerHTML = '<div class="fill"></div>';
      this.progressEl.appendChild(seg);
    }

    if (remaining > 0) {
      this.ctaButton.disabled = true;
      this.ctaButton.classList.remove('ready');
      this.ctaButtonText.textContent = 'Choose ' + remaining + ' more scent' + (remaining > 1 ? 's' : '');
    } else {
      this.ctaButton.disabled = false;
      this.ctaButton.classList.add('ready');
      this.ctaButtonText.textContent = 'Continue to checkout';
    }
  }

  render() {
    this.syncCardQuantities();
    this.renderTierRow();
    this.renderSlots();
    this.renderSizePicker(this.sizePickerDesktop);
    this.renderSizePicker(this.sizePickerMobile);
    this.renderSummary();
  }

  buildBundleSelections() {
    var counts = {};
    this.state.selectedUnits.forEach((unit) => {
      counts[unit.index] = (counts[unit.index] || 0) + 1;
    });

    var selections = [];
    var contentsLines = [];

    Object.keys(counts).forEach((index) => {
      var qty = counts[index];
      var card = this.cardByIndex(index);
      var productId = card && card.dataset.productId;
      var variantId = card && card.dataset.variantId;
      var unit = this.state.selectedUnits.filter((u) => u.index === index)[0] || {};
      var title = (card && card.dataset.productTitle) || unit.title || '';

      if (productId && variantId) {
        selections.push({
          collectionId: this.config.scentSourceCollectionId,
          externalProductId: productId,
          externalVariantId: variantId,
          quantity: qty
        });
      }

      contentsLines.push(qty + 'x ' + title);
    });

    return { selections: selections, contentsLines: contentsLines };
  }

  buildBundleItems() {
    var activeTierEl = this.querySelector('#' + this.state.bundleId);
    var variantId = activeTierEl && activeTierEl.dataset.variantId;
    var sellingPlanId = activeTierEl && activeTierEl.dataset.sellingPlanId;

    if (!variantId || !this.config.bundleProductId || !this.config.scentSourceCollectionId) {
      console.error('Bundle page is missing Recharge bundle configuration (bundle product variant / scent source collection).');
      alert('This product is misconfigured. Please contact support.');
      return Promise.resolve(null);
    }

    if (!sellingPlanId) {
      console.warn('Bundle page: no quarterly selling plan found on the active bundle variant — adding as a one-time purchase.');
    }

    return this.waitForRecharge().then(() => {
      var built = this.buildBundleSelections();

      return window.recharge.bundle
        .getBundleId({
          externalProductId: this.config.bundleProductId,
          externalVariantId: variantId,
          selections: built.selections
        })
        .then((rbId) => {
          var item = {
            id: variantId,
            quantity: 1,
            properties: {
              _rb_id: rbId,
              _bundle_contents: built.contentsLines.join('\n')
            }
          };
          if (sellingPlanId) item.selling_plan = sellingPlanId;
          return [item];
        });
    });
  }

  buildIndividualItems() {
    var counts = {};
    this.state.selectedUnits.forEach((unit) => {
      counts[unit.index] = (counts[unit.index] || 0) + 1;
    });

    var items = [];

    Object.keys(counts).forEach((index) => {
      var card = this.cardByIndex(index);
      var variantId = card && card.dataset.variantId;
      if (!variantId) return;
      items.push({
        id: variantId,
        quantity: counts[index]
      });
    });

    return Promise.resolve(items);
  }

  postCartItems(items) {
    return fetch(theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then((response) => {
        return response.json().then((data) => {
          if (!response.ok) {
            throw new Error((data && (data.description || data.message)) || 'Failed to add to cart');
          }
          return data;
        });
      })
      .then(() => {
        window.location.href = '/checkout';
      });
  }

  addToCart() {
    if (this.ctaButton.animationElement) this.ctaButton.append(this.ctaButton.animationElement);

    this.ctaButton.disabled = true;
    this.ctaButton.setAttribute('aria-busy', 'true');
    var readyLabel = this.ctaButtonText.textContent;

    var itemsPromise = this.isOneoff ? this.buildIndividualItems() : this.buildBundleItems();

    itemsPromise
      .then((items) => {
        if (!items || !items.length) return;
        return this.postCartItems(items);
      })
      .catch((err) => {
        console.error('Bundle add-to-cart failed:', err);
        alert('Something went wrong adding this bundle to your bag. Please try again.');
      })
      .finally(() => {
        this.ctaButton.removeAttribute('aria-busy');
        this.ctaButton.disabled = this.state.selectedUnits.length < this.state.bundleSize;
        this.ctaButtonText.textContent = readyLabel;
      });
  }
}

customElements.define('bundle-page', BundlePage);
